module.exports = __webpack_public_path__ + "static/media/TC_MobilePOS.adaaeeee.pdf";